import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';

import BankListPage from '@/pages/banking/BankListPage.vue';
import BankStatementsPage from '@/pages/banking/BankStatementsPage.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: 'banking',
  beforeEnter: authGuard,
  children: [
    {
      path: '',
      name: RouteNames.BANKING.INDEX,
      alias: '/pay-vendors/business-profile/banking',
      component: BankListPage,
    },
    {
      path: ':id',
      name: RouteNames.BANKING.STATEMENTS,
      component: BankStatementsPage,
    },
    // This is to keep legacy route working
    {
      path: '/pay-vendors/business-profile/banking/:id/statements',
      name: RouteNames.BANKING.STATEMENTS_LEGACY,
      component: BankStatementsPage,
    },
  ],
});
